export const useCookieConsent = () => {
  const cookie = useCookie<'accepted' | 'declined' | null>('cookie-consent', {
    maxAge: 60 * 60 * 24 * 395, // 13 months (CNIL requirement)
    sameSite: 'lax',
    path: '/',
    default: () => null,
  });

  const pending = computed(() => !cookie.value);
  const accepted = computed(() => cookie.value === 'accepted');

  const accept = () => {
    cookie.value = 'accepted';
  };
  const decline = () => {
    cookie.value = 'declined';
  };
  const reset = () => {
    cookie.value = null;
  };

  return { pending, accepted, accept, decline, reset };
};
